import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI, {Message} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/css/common.css';
import axios from 'axios'
import qs from 'qs'
import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);
Vue.use(ElementUI);

Vue.config.productionTip = false
Vue.prototype.$axios = axios

// 在Vue原型上挂载自定义Message方法
Vue.prototype.$message = function (options) {
    if (typeof options === 'string') {
        options = {
            message: options
        };
    }

    // 合并默认配置
    return Message({
        duration: 1000, // 默认3秒
        ...options
    });
};

// 添加不同类型的快捷方法
['success', 'warning', 'info', 'error'].forEach(type => {
    Vue.prototype.$message[type] = function (options) {
        if (typeof options === 'string') {
            options = {
                message: options
            };
        }
        return Vue.prototype.$message({...options, type});
    };
});


const app = new Vue({
    router,
    store,
    render: h => h(App),
    beforeCreate() {
        Vue.prototype.$bus = this //安装全局事件总线
    }
}).$mount('#app')


const env = process.env.NODE_ENV
let baseURL

if (env === 'development') {
    baseURL = 'http://127.0.0.1:8088'
} else if (env === 'production') {
    baseURL = window.location.protocol + '//' + window.location.host
} else {
    throw new Error(`Unknown environment: ${env}`);
}

axios.defaults.baseURL = baseURL
axios.defaults.crossDomain = true
axios.interceptors.request.use(
    config => {
        const token = window.localStorage.getItem('token')
        const tmpSafeCode = window.localStorage.getItem('tmpSafeCode')
        if (config.method === 'post' || config.method === 'delete') {
            if (token) {
                config.data['token'] = token
            }
            if (tmpSafeCode) {
                config.data['tmpSafeCode'] = tmpSafeCode
            }
            config.data = qs.stringify(config.data)
        } else if (config.method === 'get') {
            if (config.params == null) {
                config.params = {}
            }
            if (config.url.indexOf('nls-gateway-cn-shanghai.aliyuncs.com') === -1 && token) {
                config.params['token'] = token
            }

            if (tmpSafeCode) {
                config.params['tmpSafeCode'] = tmpSafeCode
            }

        }
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

axios.interceptors.response.use(
    resp => {
        const code = resp.data.code;
        if ([-1, -2, -3].indexOf(code) !== -1) {
            if (code === -1) {
                window.localStorage.clear()
            }
            router.push('/')
        }
        return resp
    }
)

